import { useEffect } from "react";

interface ClarityTrackingProps {
  projectId: string;
  enabled?: boolean;
  userId?: string | null;
  userEmail?: string | null;
  userName?: string | null;
}

const ClarityTracking: React.FC<ClarityTrackingProps> = ({
  projectId,
  enabled = true,
  userId,
  userEmail,
  userName,
}) => {
  useEffect(() => {
    if (!enabled || !projectId) return;

    // Load script only once
    if (!window.clarity) {
      (function (c: any, l: Document, a: string, r: string, i: string, t?: any, y?: any) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode?.insertBefore(t, y);
      })(window as any, document, "clarity", "script", projectId);
    }

    // Set user info
    if (window.clarity && userId) {
      window.clarity("identify", userId); // only once

      if (userEmail) {
        window.clarity("set", "email", userEmail);
      }

      if (userName) {
        window.clarity("set", "name", userName);
      }

      window.clarity("set", "databaseUserId", userId);
    }
  }, [projectId, enabled, userId, userEmail, userName]);

  return null;
};

export default ClarityTracking;
